import React from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import { useTheme } from '@mui/material/styles'
import { tokens } from '../theme/tokens'

interface EmptyStateProps {
  icon: React.ReactNode
  title: string
  description?: string
  action?: {
    label: string
    onClick: () => void
    startIcon?: React.ReactNode
  }
}

export default function EmptyState({
  icon,
  title,
  description,
  action
}: EmptyStateProps): JSX.Element {
  const theme = useTheme()

  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 6,   // 48px vertical
        px: 3,   // 24px horizontal
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2
      }}
    >
      {/* Icon wrapper - 64px */}
      <Box
        sx={{
          width: 64,
          height: 64,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: tokens.colors.neutral[400],
          '& > svg': {
            fontSize: 64
          }
        }}
      >
        {icon}
      </Box>

      {/* Title */}
      <Typography variant="h5" fontWeight="bold" color={theme.palette.text.primary}>
        {title}
      </Typography>

      {/* Description */}
      {description && (
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 400 }}>
          {description}
        </Typography>
      )}

      {/* Action button */}
      {action && (
        <Button
          variant="contained"
          onClick={action.onClick}
          startIcon={action.startIcon}
          sx={{
            mt: 1,
            borderRadius: tokens.radius.sm,
            textTransform: 'none'
          }}
        >
          {action.label}
        </Button>
      )}
    </Box>
  )
}
